import { render } from "./Team_post_investment_operation_m.vue?vue&type=template&id=f8b4845e&scoped=true"
import script from "./Team_post_investment_operation_m.vue?vue&type=script&lang=js"
export * from "./Team_post_investment_operation_m.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-f8b4845e"

export default script